import { useEffect, useState } from "react";
import { api } from "../../../../../../utils/api";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { toast } from "react-toastify";
import { formatCurrency } from "../../../../../../utils/formatCurrency";
import { getValidateCupom } from "../../../../../../services/CreateAccount/getValidateCupom";
import UserPaymentMethods from "../../../../../../components/payment/UserPaymentMethods";
import { useForm } from "react-hook-form";
import { getUserCreditCard } from "../../../../../../services/ClientArea/getUserCreditCard";
import ModalClientData from "../../../../../../components/payment/ModalClientData";
import ModalPixPayment from "../../../../../../components/payment/ModalPixPayment";
import { getPixGenerateLandingPage } from "../../../../../../services/LandingPages/getPixGenerateLandingPage";
import { getStatusPaymentLandingPage } from "../../../../../../services/LandingPages/getStatusPaymentLandingPage";

const PublishTemplateButton = ({
  formData,
  templateConfig,
  templateId,
  state,
  enterprise_id,
  monthlyValue,
  subscriptionValue,
  landingPageTemplateId,
  templateName,
  label = "Comprar template",
  onPublished,
  cards,
  visible,
  setCards,
  cardState,
  pixClient,
  pixDataQR,
  setVisible,
  setPixDataQR,
  handleSubmitPayment,
  baseDataForm,
  paymentMethod,
  loadingButton,
  activeIndexModal,
  handleInputFocus,
  setPaymentMethod,
  creditCardClient,
  visiblePixPayment,
  handleInputChange,
  optionsInstallments,
  setActiveIndexModal,
  setCreditCardClient,
  setVisiblePixPayment,
  visiblePaymentMethods,
  visibleModalCreditCard,
  setVisiblePaymentMethods,
  setVisibleModalCreditCard,
}) => {
  // Estados de pagamento e publicação
  const [showPayment, setShowPayment] = useState(false);
  const [paymentStep, setPaymentStep] = useState(1);
  const [cupom, setCupom] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(false);
  const [appliedCupomText, setAppliedCupomText] = useState("");
  const [discountValue, setDiscountValue] = useState(0);
  const [publishLoading, setPublishLoading] = useState(false);
  const [publishMessage, setPublishMessage] = useState("");
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [errorCupom, setErrorCupom] = useState(false);
  const form = useForm();

  // Cálculos de desconto
  const descontoAdesao =
    appliedCoupon?.subscription_fee_discount_rate && subscriptionValue
      ? subscriptionValue * appliedCoupon.subscription_fee_discount_rate
      : 0;
  const descontoMensal =
    appliedCoupon?.payments_discount_rate > 0 &&
    monthlyValue &&
    appliedCoupon.affected_payments > 0
      ? monthlyValue * appliedCoupon.payments_discount_rate
      : 0;
  const totalComDesconto =
    (subscriptionValue || 0) -
    descontoAdesao +
    (monthlyValue || 0) -
    descontoMensal;

  // Validação de cupom
  const validateCupom = async (cupom) => {
    try {
      const response = await getValidateCupom(cupom, 1);
      if (response.cupom !== false) {
        setAppliedCoupon(response.cupom);
        setAppliedCupomText(cupom); // salva o texto do cupom aplicado
        setErrorCupom(false);
      } else {
        setAppliedCoupon(false);
        setAppliedCupomText("");
        setErrorCupom(true);
      }
    } catch (e) {
      setAppliedCoupon(false);
      setAppliedCupomText("");
      setErrorCupom(true);
    }
  };

  // Função principal de publicação
  const handlePublish = async () => {
    // Se não tiver pagamento confirmado, mostra o modal de pagamento
    if (!paymentConfirmed) {
      setShowPayment(true);
      setPublishMessage("É necessário realizar o pagamento antes de publicar.");
      return;
    }
    // Se já tiver pagamento confirmado, prossegue com a publicação
    setPublishLoading(true);
    setPublishMessage("");
    try {
      const token = localStorage.getItem("@walletLoteToken");
      if (!token) {
        setPublishMessage("Você não está autenticado. Faça login novamente.");
        setPublishLoading(false);
        return;
      }
      const url = formData?.url || window.location.hostname;
      const domain = formData?.domain || "";
      const enterprise_id = state?.enterprise_id || formData?.enterprise_id;
      const templateNameFinal =
        templateConfig?.name || templateConfig?.route || templateId;
      const payload = {
        template: templateNameFinal,
        page: formData,
        domain,
        template_id: parseInt(templateId),
      };

      await api.post("/landingPage/config", payload);
      setPublishMessage("Publicado com sucesso!");
      if (onPublished) onPublished();
    } catch (err) {
      if (err.response && err.response.status === 401) {
        setPublishMessage("Não autorizado. Faça login novamente.");
      } else {
        setPublishMessage("Erro ao publicar. Tente novamente.");
      }
    } finally {
      setPublishLoading(false);
    }
  };

  useEffect(() => {
    const fetchCards = async () => {
      setIsLoading(true);
      try {
        const data = await getUserCreditCard();
        setIsLoading(false);
        setCards(data);
      } catch (error) {
        toast.error("Houve um erro ao buscar os cartões cadastrados");
      }
    };
    fetchCards();
  }, []);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const testDisabledButton = () => {
      const isCardStateEmpty = Object.values(cardState).some(
        (value) => value === ""
      );

      if (paymentMethod === "pix") {
        setDisabledButton(false);
        return;
      }

      if (
        (isCardStateEmpty || paymentMethod === null) &&
        cards.every((card) => card.active === 0)
      ) {
        setDisabledButton(true);
      } else {
        setDisabledButton(false);
      }
    };
    testDisabledButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardState, pixClient, paymentMethod, cards, visiblePaymentMethods]);

  const handleSelectCard = async (card) => {
    // console.log(card);
    const updatedData = [...cards];
    const index = updatedData.findIndex((c) => c.id === card.id);
    const indexActive = updatedData.findIndex((c) => c.active === 1);
    if (indexActive !== -1) {
      updatedData[indexActive].active = 0;
    }
    if (index !== -1) {
      updatedData[index].active = 1;
    }
    setCards(updatedData);
    setPaymentMethod(null);
  };

  const handleSelectPaymentMethod = (value) => {
    const updatedData = [...cards];
    const indexActive = updatedData.findIndex((c) => c.active === 1);
    if (indexActive !== -1) {
      updatedData[indexActive].active = 0;
    }
    setCards(updatedData);
    if (value === "card") {
      setVisiblePaymentMethods(false);
    }
    setPaymentMethod(value);
  };

  return (
    <>
      <Button
        type="button"
        rounded
        label={publishLoading ? "Publicando..." : label}
        icon="pi pi-upload"
        className="w-100 p-3 p-button-success"
        onClick={handlePublish}
        loading={publishLoading}
        disabled={publishLoading}
        style={{ marginTop: 8 }}
      />
      {publishMessage && (
        <div
          className={`mt-2 text-center ${
            publishMessage.includes("sucesso") ? "text-success" : "text-danger"
          }`}
        >
          {publishMessage}
        </div>
      )}
      <Dialog
        visible={showPayment && !paymentConfirmed}
        onHide={() => setShowPayment(false)}
        header={`Módulo - ${templateName}`}
        style={{ width: "90vw", maxWidth: "600px" }}
        modal
        dismissableMask
      >
        {/* ETAPA 1 – VALORES E CUPOM */}
        {paymentStep === 1 && (
          <>
            <div className="flex flex-column gap-2 mb-1">
              {subscriptionValue && (
                <div
                  className="d-flex justify-content-between align-items-center px-3 py-2 border-round"
                  style={{ backgroundColor: "#F8F8F8" }}
                >
                  <span
                    style={{ fontWeight: 600, fontSize: 14, color: "#686868" }}
                  >
                    Adesão
                  </span>
                  <span style={{ fontWeight: 700, fontSize: 16 }}>
                    {formatCurrency(subscriptionValue)}
                  </span>
                </div>
              )}
              {monthlyValue && (
                <div
                  className="d-flex justify-content-between align-items-center px-3 py-2 border-round"
                  style={{ backgroundColor: "#FFFFFF" }}
                >
                  <span
                    style={{ fontWeight: 600, fontSize: 14, color: "#686868" }}
                  >
                    Mensalidade
                  </span>
                  <span style={{ fontWeight: 700, fontSize: 16 }}>
                    {formatCurrency(monthlyValue)}
                  </span>
                </div>
              )}
              <div className="d-flex flex-row justify-content-between mb-3 mt-2">
                <InputText
                  name="cupom"
                  value={cupom}
                  onChange={(e) => setCupom(e.target.value)}
                  placeholder="Cupom de Desconto"
                  className="col-md-8"
                  style={{ height: "36px", fontSize: 14 }}
                />
                <Button
                  disabled={cupom.length === 0}
                  label="Aplicar"
                  className="col-md-3"
                  onClick={() => validateCupom(cupom)}
                  style={{ height: "36px", fontSize: 14 }}
                />
              </div>
              {descontoMensal > 0 && (
                <div
                  className="d-flex justify-content-between align-items-center px-3 py-2 border-round mb-1"
                  style={{ backgroundColor: "#E8F5E9" }}
                >
                  <span
                    style={{ fontWeight: 600, fontSize: 14, color: "#388E3C" }}
                  >
                    Desconto aplicado (mensalidade)
                    {appliedCoupon?.affected_payments > 1 &&
                      ` - nas ${appliedCoupon.affected_payments} primeiras parcelas`}
                    {appliedCoupon?.affected_payments === 1 &&
                      ` - na primeira parcela`}
                  </span>
                  <span
                    style={{ fontWeight: 700, fontSize: 16, color: "#388E3C" }}
                  >
                    - {formatCurrency(descontoMensal)}
                  </span>
                </div>
              )}
            </div>
            {descontoAdesao > 0 && (
              <div
                className="d-flex justify-content-between align-items-center px-3 py-2 border-round mb-2"
                style={{ backgroundColor: "#E8F5E9" }}
              >
                <span
                  style={{ fontWeight: 600, fontSize: 14, color: "#388E3C" }}
                >
                  Desconto aplicado (adesão)
                </span>
                <span
                  style={{ fontWeight: 700, fontSize: 16, color: "#388E3C" }}
                >
                  - {formatCurrency(descontoAdesao)}
                </span>
              </div>
            )}
            {appliedCoupon && (
              <div
                className="px-3 py-2 border-round text-center mb-2 d-flex align-items-center justify-content-around gap-2"
                style={{
                  border: "1px solid #14B8A6",
                  color: "#14B8A6",
                  fontWeight: "bold",
                  fontSize: 13,
                  maxWidth: "100%",
                  margin: "0 auto",
                }}
              >
                <span>"{appliedCupomText}" Ativo</span>
                <Button
                  icon="pi pi-times"
                  severity="danger"
                  aria-label="Remover cupom"
                  rounded
                  style={{ width: 24, height: 24 }}
                  onClick={() => {
                    setAppliedCoupon(false);
                    setAppliedCupomText("");
                    setCupom("");
                  }}
                />
              </div>
            )}
            <div
              className="d-flex justify-content-between align-items-center px-3 py-2 border-round"
              style={{ backgroundColor: "#f5f5f5" }}
            >
              <span style={{ fontWeight: 600, fontSize: 14, color: "#282829" }}>
                Total
              </span>
              <span style={{ fontWeight: 700, fontSize: 16, color: "#282829" }}>
                {formatCurrency(totalComDesconto)}
              </span>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center">
              <Button
                label="Prosseguir para Pagamento"
                className="w-75 mt-3 fs-5 text-center"
                onClick={() => setPaymentStep(2)}
              />
            </div>
          </>
        )}
        {/* ETAPA 2 – MÉTODO DE PAGAMENTO */}
        {paymentStep === 2 && (
          <>
            <div className="flex flex-column gap-2 mb-3">
              {subscriptionValue && (
                <div
                  className="d-flex justify-content-between text-color-secondary mb-2"
                  style={{ fontSize: 13 }}
                >
                  <span>Adesão:</span>
                  <span>{formatCurrency(subscriptionValue)}</span>
                </div>
              )}
              {descontoAdesao > 0 && (
                <div
                  className="d-flex justify-content-between mb-2"
                  style={{ fontSize: 13, color: "#388E3C" }}
                >
                  <span>Desconto (adesão):</span>
                  <span>- {formatCurrency(descontoAdesao)}</span>
                </div>
              )}
              {monthlyValue && (
                <div
                  className="d-flex justify-content-between text-color-secondary mb-2"
                  style={{ fontSize: 13 }}
                >
                  <span>Mensalidade:</span>
                  <span>{formatCurrency(monthlyValue)}</span>
                </div>
              )}
              {descontoMensal > 0 && (
                <div
                  className="d-flex justify-content-between mb-2"
                  style={{ fontSize: 13, color: "#388E3C" }}
                >
                  <span>
                    Desconto (mensalidade)
                    {appliedCoupon?.affected_payments === 1 &&
                      " - na primeira parcela"}
                    {appliedCoupon?.affected_payments > 1 &&
                      ` - nas ${appliedCoupon?.affected_payments} primeiras parcelas`}
                  </span>
                  <span>- {formatCurrency(descontoMensal)}</span>
                </div>
              )}
              {appliedCoupon && (
                <div
                  className="d-flex justify-content-between mb-2"
                  style={{ fontSize: 13, color: "#14B8A6" }}
                >
                  <span>Cupom aplicado:</span>
                  <span>{cupom}</span>
                </div>
              )}
              <div
                className="d-flex justify-content-between mb-2"
                style={{ fontWeight: "bold", fontSize: 14 }}
              >
                <span>Total:</span>
                <span>{formatCurrency(totalComDesconto)}</span>
              </div>
            </div>
            <UserPaymentMethods
              pix
              card
              cards={cards}
              form={form}
              cardState={cardState}
              paymentMethod={paymentMethod}
              setPaymentMethod={setPaymentMethod}
              handleSelectCard={handleSelectCard}
              handleInputFocus={handleInputFocus}
              creditCardClient={creditCardClient}
              handleInputChange={handleInputChange}
              setActiveIndexModal={setActiveIndexModal}
              visiblePaymentMethods={visiblePaymentMethods}
              setVisiblePaymentMethods={setVisiblePaymentMethods}
              setVisibleModalCreditCard={setVisibleModalCreditCard}
              handleSelectPaymentMethod={handleSelectPaymentMethod}
            />
            <div className="d-flex gap-2 mt-4 justify-content-between">
              <Button
                label="Voltar"
                className="p-button-outlined w-6"
                onClick={() => setPaymentStep(1)}
              />
              <Button
                label="Confirmar Pagamento"
                className="p-button-success w-6"
                disabled={disabledButton}
                onClick={async () => {
                  try {
                    await handleSubmitPayment(
                      landingPageTemplateId,
                      appliedCoupon ? cupom : undefined
                    );
                    setPaymentConfirmed(true);
                    setShowPayment(false);
                    handlePublish(); // Chama handlePublish após pagamento confirmado
                  } catch (error) {
                    console.error("Erro ao processar pagamento:", error);
                  }
                  // setPaymentConfirmed(true);
                  // setShowPayment(false);
                  // handlePublish();
                }}
              />
            </div>
          </>
        )}
      </Dialog>
      <ModalClientData
        noData
        baseDataForm={baseDataForm}
        activeIndex={activeIndexModal}
        visible={visibleModalCreditCard}
        creditCardClient={creditCardClient}
        setActiveIndex={setActiveIndexModal}
        setVisible={setVisibleModalCreditCard}
        setCreditCardClient={setCreditCardClient}
      />

      <ModalPixPayment
        functionInUse={getPixGenerateLandingPage}
        pixDataQR={pixDataQR}
        setPixDataQR={setPixDataQR}
        visible={visiblePixPayment}
        setVisible={setVisiblePixPayment}
        functionCallback={getStatusPaymentLandingPage}
        onContinue={() => {
          setVisiblePixPayment(false);
          setVisible(false);
        }}
      />
    </>
  );
};

export default PublishTemplateButton;
